/**
 * Sticky ATC Bar Color Selector
 * Controls the expand/collapse behavior of the color selector in the sticky ATC bar
 */
(function() {
  'use strict';

  function initColorSelectors() {
    const colorSelectors = document.querySelectorAll('[data-color-selector]');
    
    if (colorSelectors.length === 0) return;
    
    colorSelectors.forEach(selector => {
      if (selector.dataset.initialized === 'true') return;
      selector.dataset.initialized = 'true';
      
      const toggle = selector.querySelector('[data-color-toggle]');
      const options = selector.querySelector('[data-color-options]');
      
      if (!toggle || !options) return;
      
      // Toggle click handler
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const isOpen = selector.classList.contains('is-open');
        
        document.querySelectorAll('[data-color-selector]').forEach(otherSelector => {
          if (otherSelector !== selector) {
            otherSelector.classList.remove('is-open');
          }
        });
        
        selector.classList.toggle('is-open', !isOpen);
      });
    });
  }

  document.addEventListener('click', function(e) {
    if (!e.target.closest('[data-color-selector]')) {
      document.querySelectorAll('[data-color-selector].is-open').forEach(selector => {
        selector.classList.remove('is-open');
      });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColorSelectors);
  } else {
    initColorSelectors();
  }

  // [AUDIT FIX #5] Observer scoped to .sticky-atc-bar only — prevents firing on every DOM
  // mutation across the entire page. setTimeout fallbacks removed; the DOMContentLoaded
  // listener above already handles late initialization.
  const stickyBar = document.querySelector('.sticky-atc-bar');
  if (stickyBar) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          initColorSelectors();
        }
      });
    });

    observer.observe(stickyBar, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }
})();
